













import { Component, Vue } from 'vue-property-decorator';
import Headline from '@/components/welcome/sections/Headline.vue';
import Review from '@/components/welcome/sections/Review.vue';
import Features from '@/components/welcome/sections/Features.vue';
import Value from '@/components/welcome/sections/Value.vue';
import Documentation from '@/components/welcome/sections/Documentation.vue';
import Standards from '@/components/welcome/sections/Standards.vue';
import Learning from '@/components/welcome/sections/Learning.vue';
import Signup from '@/components/core/Signup.vue';

@Component({
  components: {
    Headline,
    Review,
    Features,
    Value,
    Documentation,
    Standards,
    Learning,
    Signup
  }
})
export default class Welcome extends Vue {
}
